export const adaptAlertDataToServer = ({
  moveIn,
  moveOut,
  minPrice,
  maxPrice,
  propertyTypes,
  cityId,
  mediums,
  ...rest
}) => ({
  ...rest,
  input: {
    cityId,
    mediums,
    moveIn: moveIn || null,
    moveOut: moveOut || null,
    minPrice: minPrice || null,
    maxPrice: maxPrice || null,
    propertyTypes: propertyTypes || null
  }
});

export const adaptAlertDataToClient = (response, key) => {
  const {
    moveIn,
    moveOut,
    minPrice,
    maxPrice,
    propertyTypes,
    ...rest
  } = response.data[key];
  return {
    ...rest,
    moveIn: moveIn || '',
    moveOut: moveOut || '',
    minPrice: minPrice || 0,
    maxPrice: maxPrice || 0,
    propertyTypes: propertyTypes || []
  };
};

export default {
  adaptAlertDataToServer,
  adaptAlertDataToClient
};
